// extracted by mini-css-extract-plugin
module.exports = {"banner":"space_banner__YeuhL","tree":"space_tree__CR8YJ","column":"space_column__q6_GZ","mono":"space_mono__DkxvP"};